import React, { useEffect } from 'react';
import './NewsletterPage.scss';
import { Helmet } from 'react-helmet-async';
import { baseStrapiURL, baseURL } from '../../services/config';
import { useContentQuery } from '../../services/strapi/hooks';
import Loading from '../../components/Loading/Loading';
import { useQueryClient } from '@tanstack/react-query';
import Error404Page from '../Error404Page/Error404Page';
import StrapiImageWithSkeleton from '../../components/StrapiImageWithSkeleton/StrapiImageWithSkeleton';
import NewsletterForm from './components/NewsletterForm/NewsletterForm';
import { useMediaQuery } from 'react-responsive';
import { safeHtml } from '../../services/helpers';

const NewsletterPage = ({setNotification, setNewsletterModalContent, setShowNewsletterModal}) => {

    const strapiPage = 'newsletter-subscription';
    const isTab = useMediaQuery({ maxWidth: 1023 }); // Breakpoint pour LG

    const queryClient = useQueryClient();

    // Utilisation du hook personnalisé pour récupérer les données
    const { data: strapiData, isLoading, error } = useContentQuery(strapiPage);

    // Obtenir les données mises en cache ou les données actuelles
    const displayData = strapiData || queryClient.getQueryData(['strapi-content', strapiPage]);

    // N'afficher le chargement que si les données ne sont pas disponibles
    const showLoading = isLoading && !displayData;

    useEffect(() => {
        window.scroll(0, 0);
        if (displayData) {
            setNewsletterModalContent({
                Remerciements: displayData.Remerciements,
            })
        }
    }, [displayData]);

    if (showLoading) return <Loading />;
    if (!displayData || displayData.length === 0 || error) return <Error404Page />;

    return (
        <div className="newsletter-page">
            <Helmet>
                {/* Open Graph (utilisé par Facebook, LinkedIn, etc.) */}
                <meta property="og:title" content={displayData.SEO.TitreOnglet} />
                <meta property="og:description" content={displayData.SEO.Description} />
                <meta property="og:image" content={baseStrapiURL + displayData.SEO.PhotoReseauxSociaux_1200x630.url} />
                <meta property="og:url" content={displayData.Slug === null ? baseURL : baseURL + '/' + displayData.Slug} />
                <meta property="og:type" content="website" />

                {/* Twitter Cards */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={displayData.SEO.TitreOnglet} />
                <meta name="twitter:description" content={displayData.SEO.Description} />
                <meta name="twitter:image" content={baseStrapiURL + displayData.SEO.PhotoReseauxSociaux_1200x630.url} />
                <meta name="twitter:url" content={displayData.Slug === null ? baseURL : baseURL + '/' + displayData.Slug} />

                <title>{displayData.SEO.TitreOnglet}</title>
                <meta name="description" content={displayData.SEO.Description} />
                <link
                    rel="preload"
                    as="image"
                    href="/assets/newsletter/background.jpg"
                    fetchPriority="high"
                />
                <link
                    rel="preload"
                    as="image"
                    href="/assets/newsletter/background.webp"
                    fetchPriority="high"
                />
            </Helmet>
            <div className="picture-container">
                <StrapiImageWithSkeleton
                    picture={strapiData.EnTete.Photo}
                    loading="lazy"
                />
                <div className="newsletter-page__content">
                    {
                        isTab ?
                            <div className="newsletter-page__text" dangerouslySetInnerHTML={safeHtml(strapiData.EnTete.TexteMobile)} />

                            :
                            <div className="newsletter-page__text" dangerouslySetInnerHTML={safeHtml(strapiData.EnTete.Texte)} />
                    }

                    <NewsletterForm
                        setNotification={setNotification}
                        setShowNewsletterModal={setShowNewsletterModal}
                    />
                </div>
            </div>
        </div>
    );
};

export default NewsletterPage;